export default [
[
       {name: 'Statewide Mitigation Goals', path: '/strategies'},
       {name: 'Mitigation Actions', path: '/strategies/actions'},
       {name: 'Mitigation Measures', path: '/strategies/measures'},
       {name: 'Mitigation Funding Sources', path: '/strategies/funding'},

       
    ]
]